/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/copy_sign.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a value with the magnitude of the first argument and the sign of the second argument.
 * This function is similar to Java's Math.copySign(double magnitude, double sign) which is
 * similar to `copysign` from IEEE 754.
 *
 * @example
 * FROM employees
 * | EVAL cs1 = COPY_SIGN(salary, LEAST(salary_change))
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'copy_sign',
  signatures: [
    {
      params: [
        {
          name: 'magnitude',
          type: 'double',
          optional: false,
        },
        {
          name: 'sign',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'double',
          optional: false,
        },
        {
          name: 'sign',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'double',
          optional: false,
        },
        {
          name: 'sign',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'integer',
          optional: false,
        },
        {
          name: 'sign',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'integer',
          optional: false,
        },
        {
          name: 'sign',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'integer',
          optional: false,
        },
        {
          name: 'sign',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'long',
          optional: false,
        },
        {
          name: 'sign',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'long',
          optional: false,
        },
        {
          name: 'sign',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'magnitude',
          type: 'long',
          optional: false,
        },
        {
          name: 'sign',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
